import { post } from '@/api'

import {
	POST_POPULAR_FETCH,
	POST_POPULAR_FETCH_ERROR,
	POST_POPULAR_PREVIEW_GET,
	POST_POPULAR_PREVIEW_GET_ERROR,
	POST_POPULAR_BY_CATEGORY_FETCH,
	POST_POPULAR_BY_CATEGORY_FETCH_ERROR,
	POST_POPULAR_PREVIEW_GET_LOADING,
	POST_POPULAR_LOADING,
} from './types'

const getPopularPostsPreview = async (ctx, query) => {
	ctx.commit(POST_POPULAR_PREVIEW_GET_LOADING, true)
	try {
		const { data } = await post.fetchPopularPosts(query)
		ctx.commit(POST_POPULAR_PREVIEW_GET, data.data)
		ctx.commit(POST_POPULAR_PREVIEW_GET_LOADING, false)
	} catch (e) {
		ctx.commit(POST_POPULAR_PREVIEW_GET_ERROR, e)
		throw e
	}
}

const fetchPopularPosts = async (ctx, query) => {
	ctx.commit(POST_POPULAR_LOADING, true)
	try {
		const { data } = await post.fetchPopularPosts(query)
		ctx.commit(POST_POPULAR_FETCH, data)
		ctx.commit(POST_POPULAR_LOADING, false)
	} catch (e) {
		ctx.commit(POST_POPULAR_FETCH_ERROR, e)
		throw e
	}
}

const fetchPopularPostsByCategory = async (ctx, query) => {
	ctx.commit(POST_POPULAR_LOADING, true)
	try {
		const { data } = await post.fetchPopularPostsByCategories(query)
		ctx.commit(POST_POPULAR_BY_CATEGORY_FETCH, data)
		ctx.commit(POST_POPULAR_LOADING, false)
	} catch (e) {
		ctx.commit(POST_POPULAR_BY_CATEGORY_FETCH_ERROR, e)
		throw e
	}
}

export default {
	getPopularPostsPreview,
	fetchPopularPosts,
	fetchPopularPostsByCategory,
}
